import { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../redux/hooks'
import { instructorSearchConnector } from '../../server/connector/InstructorSearchConnector';
import { updateExploreProfiles } from '../../redux/reducers/searchSlice'
import BackToTopButton from '../../components/backToTopButton/BackToTopButton'
import AppFooter from '../../sections/footer/AppFooter'
import { userStateData } from '../../data/userStateData';
import { PAGE_URLS } from '../../constants/hrefLinks';
import HeaderAppSettings from '../../sections/header/HeaderAppSettings';

import './style.scss';

function AppProfile() {
	const [firstSearchLoaded, setFirstSearchLoaded] = useState<boolean>(false)

	const dispatch = useAppDispatch()

	useEffect(() => {
		// Assumes the log in check is done in the root App component before any page components are added to the dom
		if (userStateData.loggedIn) {
			makeInitialSearchRequest()
		} else {
			window.location.replace(`${PAGE_URLS.APP_ENTRY}`)
		}
	}, [])

	const makeInitialSearchRequest = () => {
		instructorSearchConnector.performExploreSearchRequest().then((successRequest) => {
			setFirstSearchLoaded(true)
			dispatch(updateExploreProfiles())
			if (!successRequest) {
				console.log('WARNING - [AppExplore] - makeInitialSearchRequest() failed')
			}
		})
	}

	return (
		<>
			{firstSearchLoaded &&
				<>
					<div className='section-wrap section-seperator lcp-shift-min-height extra-footer-space app-profile-full-section'>
						<div className='app-profile-top-section-wrap'>
							<div className='app-profile-top-section'>
								<div
									className='app-profile-img-wrap'
									// href={PAGE_URLS.DASHBOARD_CUSTOMER}
								>
									<img 
										className='app-profile-img'
										src={userStateData.getUserIconUrl()}
										alt='Profile'
									/>
								</div>
							</div>
							<div className='app-profile-top-section f-grow-1'>
								<div className='app-profile-top-name'>Steven</div>
								<div className='app-profile-sub-text'>Joined ...</div>
								<div className='app-profile-details-wrap'>
									<div className='app-profile-details-section'>
										<div className='app-profile-details-section-value'>0</div>
										<div className='app-profile-details-section-label'>Friends</div>
									</div>
									<div className='app-profile-details-section'>
										<div className='app-profile-details-section-value'>0</div>
										<div className='app-profile-details-section-label'>Communities</div>
									</div>
								</div>
								<img
									src={'/imgs/icons/instructor/icon-instructor-header-bell-button.svg'}
									className='app-profile-top-section-bell'
									alt='Bell Button'
								/>
								<img
									src={'/imgs/icons/profile/icon-instructor-header-settings-button.svg'}
									className='app-profile-top-section-settings'
									alt='Settings Button'
									onClick={() => {
										window.location.replace(`${PAGE_URLS.APP_SETTINGS}`)
									}}
								/>
							</div>
						</div>
						<div className='app-profile-bio-section-wrap'>
							<div className='app-profile-bio-section'>
								This is where the<br/>Bio details go for<br/>the profile.
							</div>
							<div className='app-profile-bio-section'>
								<div className='app-profile-bio-section-button'>
									<div className='app-profile-bio-section-button-label'>Edit Profile</div>
								</div>
								<div className='app-profile-bio-section-button'>
									<div className='app-profile-bio-section-button-label'>Share Profile</div>
								</div>
							</div>
						</div>
						<div className='app-profile-content-section-wrap'>
							<div className='app-profile-content-section-empty-text'>
								<div className='app-profile-content-section-empty-text-title'>You haven't posted anything yet...</div>
								<div className='app-profile-content-section-empty-text-sub-text'>Get started by going to communities<br/>and tapping the post button!</div>
							</div>
						</div>
					</div>
					<BackToTopButton />
				</>
			}
			<AppFooter activeIndex={4} />
		</>
	)
}

export default AppProfile
